import React, { useCallback, useRef, useState, useEffect } from 'react';
import { GlobalStyle } from '../../styles/global';
import logoImg from '../../assets/metodo-billings-marca-dashboard.png';
import logogoogle from '../../assets/logogoogle.png';
import { useGoogleLogin } from '@react-oauth/google';
import { Link, useHistory } from 'react-router-dom';
import * as Yup from 'yup';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import Input from '../../components/Elements/Input';
import Button from '../../components/Elements/Button';
import { Container } from './styles';
import getValidationErros from '../../utils/getValidationErros';
import { useAuth } from '../../hooks/Auth';
import toast from 'react-hot-toast';
import {api} from '../../services/api';
import { BgModal, BoxModal } from '../../components/Modal/styles'


interface SignInFormData{
    email: string;
    pass: string;
}

const SignIn: React.FC = () => {

    const formRef = useRef<FormHandles>(null);
    const { signIn } = useAuth();
    const history = useHistory();

    const googleLogin = useGoogleLogin({
        onSuccess: async (tokenResponse) => {
            try {
                // Buscar dados do usuário usando o token de acesso
                const userInfoResponse = await fetch(`https://www.googleapis.com/oauth2/v3/userinfo?access_token=${tokenResponse.access_token}`);
                const userProfile = await userInfoResponse.json();
                
                const userID = userProfile.sub; // Google ID
                const userName = userProfile.name;
                const userEmail = userProfile.email;
                const userPicture = userProfile.picture || null;
                const LoR = tokenResponse.access_token; // Token de acesso
                
                const datag = { 
                    userID: userID, 
                    userName: userName, 
                    userEmail: userEmail, 
                    userPicture: userPicture, 
                    token: LoR 
                };

                const resp = await api.post('login_google.php', datag);

                localStorage.setItem('@mob:jwt', resp.data.jwt);
                localStorage.setItem('@mob:user', JSON.stringify(resp.data.user));

                window.location.reload();

            } catch (err: any) {
                let error = err.toString();
                if(error.search("Network Error")){
                    toast.loading('ESTAMOS COM PROBLEMAS NO BANCO DE DADOS, POR FAVOR TENTE MAIS TARDE.');
                    setShowModalRestrict(true);
                } else {
                    toast.error('DESCULPE NÃO CONSEGUIMOS ACESSO');
                }
            }
        },
        onError: () => {
            toast.error('NÃO AUTORIZADO.');
        },
        flow: 'implicit', // ou 'auth-code' dependendo do que seu backend espera
    });

    const handleLogin = useCallback(async (data: SignInFormData) => {        
        try {

            formRef.current?.setErrors({});
            const schema = Yup.object().shape({
                email: Yup.string().required('Email obrigatório').email('Insira um email válido'),
                pass: Yup.string().required('Senha Obrigatória'),
            });
            await schema.validate(data, { abortEarly: false, });

            await signIn({ 
                email: data.email, 
                pass: data.pass,
            });            
            history.push('/dashboard');
        } catch (err) {   
            if(err instanceof Yup.ValidationError){
                const errors = getValidationErros(err);
                formRef.current?.setErrors(errors);
                return;
            }
        }
    }, [history, signIn]);


    const [showModalRestrict, setShowModalRestrict] = useState(false);
    
    useEffect(() => {
        // console.log("Checando API");
        const checkApi = async () => {
          try {
            const res = await api.get('ping.php', {
                headers: {
                "Cache-Control": "no-cache",
                },
                timeout: 7000,
            });
            if (!res.data || res.data.status !== "ok") {
              throw new Error("Resposta inesperada");
            }
    
            setShowModalRestrict(false);
            console.log("Api OK");
          } catch (err) {
            // console.log("Restrição na Rede");
            setShowModalRestrict(true);
          }
        };
    
        checkApi();
      }, []);

   
    return ( 
    <>
        <Container>
            <img src={logoImg} alt="Método Billings" />
            <Form ref={formRef} onSubmit={handleLogin}>
                <Input type="text" defaultValue="" name="email" placeholder="SEU EMAIL" />
                <Input type="password" defaultValue="" name='pass' placeholder="SUA SENHA" />
                <Button type="submit">entrar</Button>                
                
                <button className="google" onClick={() => googleLogin()}>
                    <img src={logogoogle} alt="" />
                    USAR O GOOGLE
                </button>

                <div className="outros">
                    <Link to="/cadastro" className="botao">Fazer cadastro</Link>
                    <Link to="/esqueciasenha" className="botao">Esqueci a senha</Link>
                </div>
            </Form>
        </Container>
        <BgModal show={showModalRestrict}>
            <BoxModal>
                <div className="topo">
                    <span>Atenção</span>
                    <button type='button' className="close" onClick={() => setShowModalRestrict(false)}><span className="material-icons">close</span></button>
                </div>
                <div className="content" style={{textTransform: 'uppercase', textAlign: 'center'}}>
                    Pode ser que você esteja com restrições nas sua conexão, por favor, clique no botão abaixo para verificar, e tente novamente.
                    <br /><br />
                    <a style={{
                        textDecoration: 'none', 
                        backgroundColor: '#19c470', 
                        color: '#000',
                        fontWeight: 'bold',
                        padding: '10px 20px',
                        display: 'inline-block',
                        borderRadius: '50px',
                        }} className="botao" rel="noreferrer" href="https://api3.metodobillings.com.br/desblockApi.php" target="_blank"> 
                    VERIFICAR RESTRIÇÃO
                    </a><br/><br/>
                    <small style={{display: 'block', lineHeight: '1', paddingLeft: '0.4rem', paddingRight: '0.4rem'}}>
                        Você será redirecionado para outra página, <br/>
                        <strong style={{fontWeight: 'bold'}}>resolva o captcha</strong> (se aparecer) <br/>
                        e tente novamente.
                    </small>
                </div>
            </BoxModal>
        </BgModal>    
        <GlobalStyle />
    </>
    );
}

export default SignIn;